<template>
  <scroll-bar>
    <div class="logo">
      <img :src="icon" alt="" class="logo-img" />
    </div>

    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#001529"
      text-color="#FFFFFF"
      active-text-color="#479DFF"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import ScrollBar from "@/components/ScrollBar";
import { getCookie } from "@/utils/support";
export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters(["sidebar"]),
    routes() {
      return this.$router.options.routes;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  mounted() {
    this.$EventBus.$on("advanced", data => {
      console.log(getCookie("icon"));
      this.icon = getCookie("icon");
      console.log("111", data);
    });
  },
  destroyed() {
    this.$EventBus.$off("advanced");
  },
  data() {
    return {
      icon: getCookie("icon")
    };
  }
};
</script>

<style lang="scss">
.logo {
  width: 100%;
  height: 68px;
  position: relative;
  .logo-img {
    position: absolute;
    width: 28px;
    height: 28px;
    left: calc(50% - 14px);
    top: calc(50% - 14px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue